<template>
  <el-dialog
    v-loading="isLoading"
    title="Add New Tracking Event"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
  >
    <el-form label-width="120px">
      <el-row>
        <el-col :md="8">
          <el-form-item
            v-loading="isLoadingLevels"
            label="Level"
          >
            <el-select
              v-model="tracking.level"
              placeholder="Select A Level"
              value-key="id"
            >
              <el-option
                v-for="(level) in levels"
                :key="level.id"
                :label="level.name"
                :value="level"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="Scan Date">
            <el-date-picker
              v-model="scan.scanned_at"
              type="datetime"
              placeholder="Select Date and Time"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-row>
            <el-form-item label="Item (Optional)">
              <el-select
                v-model="tracking.consignment_item"
                placeholder="Leave blank for consignment"
              >
                <el-option
                  v-for="(item) in consignment.items"
                  :key="item.id"
                  :label="item.item_full"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="8">
          <el-form-item label="Depot">
            <el-input
              v-model="scan.depot"
              placeholder="Enter depot name"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="Signed By">
            <el-input
              v-model="scan.signed_by"
              placeholder="Enter name of person signing"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="POD">
            <el-select
              v-model="scan.proof_of_delivery"
              placeholder="Select an attachment"
            >
              <el-option
                v-for="(item) in attachments"
                :key="item.id"
                :label="item.file.name"
                :value="item.file"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template #footer>
      <el-button
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        @click.native="createEvent"
      >
        Create
      </el-button>
    </template>
  </el-dialog>
</template>
<script>
export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      isLoadingLevels: true,
      isVisible: true,
      tracking: {
        manually_created: true
      },
      scan: {
        scanned_at: null,
        proof_of_delivery: null,
        depot: '',
        signed_by: ''
      },
      levels: [],
      attachments: []
    }
  },
  created () {
    this.loadLevels()
    this.loadAttachments()
  },
  methods: {
    loadAttachments () {
      this.$sdk.attachment.list(builder => {
        builder.context = { resource: 'consignment', id: this.consignment.id }
        builder.page = 1
        builder.limit = 1000
        builder.order = 'created_at:desc'
      }).then(res => {
        this.attachments = res
      })
    },
    loadLevels () {
      this.$sdk.tracking_level.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'name:asc'
      }).then(res => {
        this.levels = res
        this.isLoadingLevels = false
      })
    },
    createEvent () {
      this.isLoading = true
      this.$sdk.scan.create(this.scan, builder => {
      }).then(async res => {
        this.tracking.scan = await res
        this.tracking.consignment = this.consignment
        this.$sdk.tracking.create(this.tracking, builder => {
        }).then(res => {
          this.$message({ message: 'Event Added', type: 'success' })
          this.queueBlobUpdate()
        })
          .finally(() => {
            this.isLoading = false
            this.isVisible = false
          })
      })
    },
    queueBlobUpdate () {
      const job = new this.$sdk.job()
      job.name = 'tracking.blob.update'
      job.parameters = {
        consignment: this.consignment.id
      }
      job.create()
        .then(() => this.$message({ message: this.consignment.con_full + ' Tracking Update Queued', type: 'success' }))
    }
  }
}
</script>
